import { useCallback, useEffect, useMemo, useState } from 'react';

import { ModalPopup, ModalPopupProps, PopupDialogOption } from '../common/components/ModalPopup';
import { createOverlayComp, OverlayCompProps } from '../common/util/createOverlayComp';

function PopupComponent({ resolve, dispose, buttons, ...props }: ModalPopupProps & OverlayCompProps) {
  const [active, setActive] = useState(true);
  const proceed = useCallback(
    (value: string) => {
      resolve?.(value);
      setActive(false);
      dispose?.();
    },
    [resolve, setActive, dispose],
  );
  const handleSubmit = useCallback(
    (id: string) => {
      resolve?.(id);
      dispose?.();
    },
    [dispose, resolve],
  );
  const buttonsWithSubmit = useMemo(() => {
    return buttons?.map((value, index) => ({
      ...value,
      id: value?.id ?? String(index),
      onClick: () => {
        value.onClick?.();
        handleSubmit(value.id ?? String(index));
      },
    }));
  }, [buttons, handleSubmit]);

  const handleOutsideClick = useCallback(() => {
    proceed('skip');
  }, [proceed]);

  useEffect(() => {
    return () => {
      dispose?.();
    };
  }, [dispose]);
  return (
    <ModalPopup
      {...props}
      active={active}
      handleOutsideClick={handleOutsideClick}
      buttons={buttonsWithSubmit}
      close={dispose}
    />
  );
}

function renderToast(option: PopupDialogOption) {
  return ({ resolve, dispose }: OverlayCompProps) => {
    return <PopupComponent {...{ ...option, resolve, dispose }} />;
  };
}
const openToast = createOverlayComp(renderToast);

export class Popup {
  static async open(option: PopupDialogOption) {
    return openToast(option);
  }
}
